import { IResource, ISchedule } from "@gettactic/api";
import { getScheduleDateWithTime } from "@gettactic/helpers";
import { areIntervalsOverlapping } from "date-fns";

export const isResourceAvailableByCapacity = (
  resource: IResource | null | undefined,
  schedules: ISchedule[],
  start: Date | undefined,
  durationMins: number
): boolean => {
  if (!resource || !start || !durationMins) return false;

  const capacity = resource.available_slots;
  if (!capacity) return false;

  const end = new Date(start.getTime() + durationMins * 60000);

  // Filter schedules that overlap with the proposed time
  const overlappingSchedules = (schedules || []).filter((schedule) => {
    const scheduleStart = new Date(schedule.start);
    const scheduleEnd = new Date(schedule.end);
    return areIntervalsOverlapping(
      { start, end },
      {
        start: new Date(getScheduleDateWithTime(schedule.start)),
        end: new Date(getScheduleDateWithTime(schedule.end))
      }
    );
  });
  // If no overlaps, it's available (assuming capacity >= 1)
  if (overlappingSchedules?.length === 0 || !overlappingSchedules?.length)
    return true;

  // add more conditions if needed
  return false;
};
